import { render, staticRenderFns } from "./Emcd.vue?vue&type=template&id=0efb07ca&scoped=true&"
import script from "./Emcd.vue?vue&type=script&lang=js&"
export * from "./Emcd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efb07ca",
  null
  
)

export default component.exports